import { LicenseManager } from 'ag-grid-enterprise'

export function useAgGridLicense () {
  const agGridLicenseKey = import.meta.env.DEV
    ? import.meta.env.VITE_AGGRID_LICENSE_KEY // load key from .env.local in dev mode
    : window.siteVars.agGridLicenseKey

  if (!LicenseManager.getLicenseDetails().valid) LicenseManager.setLicenseKey(agGridLicenseKey)

  return {
    isValid: LicenseManager.getLicenseDetails().valid,
  }
}
